"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Not = Not;
const type_1 = require("../clone/type");
const index_1 = require("../symbols/index");
/** `[Json]` Creates a Not type */
function Not(schema, options) {
    return {
        ...options,
        [index_1.Kind]: 'Not',
        not: (0, type_1.CloneType)(schema),
    };
}
